import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=6b2a0bac&"
import script from "./Logs.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Logs.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports